import React, { Component } from 'react';
import { Nav } from 'reactstrap';
import { AppNavbarBrand, AppSidebarToggler } from '@coreui/react';
import logo from '../assets/logo.png';
import text from '../assets/texts.json';
import AuthMenu from '../modules/auth/views/menu';

class Header extends Component {
  render() {
    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <AppSidebarToggler className="d-md-down-none" display="lg" />
        <AppNavbarBrand
          full={{ src: logo, height: 30, alt: text.title }}
        />
        <Nav className="ml-auto px-3" navbar>
          <AuthMenu />
        </Nav>
      </React.Fragment>
    );
  }
}

export default Header;
